/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DoCheck, Input, signal} from '@angular/core';
import {ADMIN_LIST_IMPORTS} from './admin-list-imports';

@Component({
  standalone: true,
  imports: ADMIN_LIST_IMPORTS,
  selector: 'adn-list-count-badge',
  template: '{{ countText }}',
  styles: [':host { display: inline-block; }']
})
export class ListCountBadgeComponent implements DoCheck {
  @Input() list: any;

  private readonly countTextState = signal('');

  get countText(): string {
    return this.countTextState();
  }

  ngDoCheck(): void {
    const countText = this.list?.totalCountText || '';
    if (countText !== this.countTextState()) {
      this.countTextState.set(countText);
    }
  }
}
